import Chocolat from 'chocolat';

Chocolat(document.querySelectorAll('.chocolat-parent .chocolat-image'), {});
